import { Component } from '@angular/core';
import { AuthService } from '@core/services/api/auth.service';

@Component({
  selector: 'app-google-auth-smart',
  template: `
    <app-google-auth-presentation
      (emitGoogleSignIn)="signInWithGoogle()"
    ></app-google-auth-presentation>
  `,
})
export class GoogleAuthSmartComponent {
  constructor(private authService: AuthService) {}

  public signInWithGoogle(): void {
    this.authService
      .requestGoogleRedirectUri()
      .subscribe((response: { redirect_uri: string }) => {
        window.location.replace(response.redirect_uri);
      });
  }
}
